import { Space } from 'antd'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { CIMSTags } from 'components/CIMSTags'

export const useEJTypesPanel = (
  types: { name: string }[]
): CIMSCollapsePanelOptions[] =>
  !!types.length
    ? [
        {
          key: `ej-types-${Math.random()}`,
          header: 'Engineering Judgements',
          children: (
            <Space direction="vertical" size="small">
              {'Types:'}
              <CIMSTags
                tags={types.map(({ name }) => ({
                  text: name,
                }))}
              />
            </Space>
          ),
        },
      ]
    : []
